import { withStyles } from "@material-ui/core/styles";
import { PieGraph } from "./piegraph.component";

export const StyledPieGraph = withStyles((theme) => ({
  root: {
    width: "100%",
    minWidth: "min-content",
    display: "block",
    background:
      "-webkit-linear-gradient(45deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)",

    "& > *": {
      margin: "10px",
      width: "min-content"
    }
  },
  title: {
    fontSize: "30px",
    fontWeight: "bold",
    width:"auto",
    margin: "auto",
    height: "auto",
    textAlign: "left",
    color: "black",
    padding: "10px"
  },
  title2: {
    width:"auto",
    fontSize:"18px",
    margin: "auto",
    textAlign: "middle",
    fontWeight: "bold",
    color: "black",
    padding: "10px"
  },
  svgText: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fill: "black"
  }
}))(PieGraph);
